
import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { supabase } from "../lib/supabaseClient";
import { useUnreadTickets } from "../hooks/useUnreadTickets";
import { useSquadNotifications } from "../hooks/useSquadNotifications";
import NotificationBadge from "./NotificationBadge";
import { Button as FcButton, NavigationLink as FcNavigationLink } from '../ui';

// SVG icon constants (reuse from BottomNavbar or define here)
const DashboardIcon = (
  <svg width="24" height="21" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.526 0.845766L22.7719 9.53931C23.16 9.88861 23.1989 10.4708 22.8884 10.8589C22.5391 11.247 21.9569 11.2858 21.5688 10.9753L20.6374 10.1603V17.379C20.6374 19.1255 19.2402 20.4839 17.5325 20.4839H6.35511C4.60864 20.4839 3.25027 19.1255 3.25027 17.379V10.1603L2.28001 10.9753C1.8919 11.2858 1.30975 11.247 0.960453 10.8589C0.649969 10.4708 0.688779 9.88861 1.07688 9.53931L11.3229 0.845766C11.6721 0.574093 12.1767 0.574093 12.526 0.845766ZM5.11317 17.379C5.11317 18.0776 5.65652 18.621 6.35511 18.621H8.21801V12.7218C8.21801 11.8679 8.87779 11.1694 9.77043 11.1694H14.1172C14.971 11.1694 15.6696 11.8679 15.6696 12.7218V18.621H17.5325C18.1923 18.621 18.7745 18.0776 18.7745 17.379V8.56905L11.9438 2.78629L5.11317 8.56905V17.379ZM10.0809 18.621H13.8067V13.0323H10.0809V18.621Z" fill="white"/>
  </svg>
);
const CompetitionsIcon = (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 16C9.32636 16 7.86971 17.265 7.11766 19.1312C6.75846 20.0225 7.27389 21 7.95877 21H14.0412C14.7261 21 15.2415 20.0225 14.8823 19.1312C14.1303 17.265 12.6736 16 11 16Z" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M17.5 4H18.7022C19.9031 4 20.5035 4 20.8168 4.37736C21.13 4.75472 20.9998 5.32113 20.7393 6.45395L20.3485 8.15307C19.7609 10.7086 17.6109 12.6088 15 13" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4.5 4H3.29779C2.09692 4 1.49649 4 1.18324 4.37736C0.86999 4.75472 1.00024 5.32113 1.26075 6.45395L1.65148 8.15307C2.23914 10.7086 4.38912 12.6088 7 13" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11 16C14.0208 16 16.565 11.3379 17.3297 4.99089C17.5412 3.23558 17.647 2.35793 17.0868 1.67896C16.5267 1 15.6223 1 13.8134 1H8.18658C6.37775 1 5.47333 1 4.91317 1.67896C4.35301 2.35793 4.45875 3.23558 4.67025 4.99089C5.435 11.3379 7.97923 16 11 16Z" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);
const MyCompetitionsIcon = (
  <svg width="32" height="22" viewBox="0 0 32 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="31" height="20.8537" rx="0.5" stroke="white"/>
    <rect x="0.5" y="5.18262" width="5.2439" height="11.4878" rx="0.5" stroke="white"/>
    <rect x="0.5" y="8.30469" width="2.12195" height="5.2439" rx="0.5" stroke="white"/>
    <rect x="29.3779" y="8.30469" width="2.12195" height="5.2439" rx="0.5" stroke="white"/>
    <rect x="26.2559" y="5.18262" width="5.2439" height="11.4878" rx="0.5" stroke="white"/>
    <line x1="16.1094" y1="2.18557e-08" x2="16.1094" y2="6.2439" stroke="white"/>
    <line x1="16.1094" y1="16.3906" x2="16.1094" y2="21.854" stroke="white"/>
    <circle cx="15.9999" cy="11.3173" r="4.57317" stroke="white"/>
    <path d="M14.0484 13.585L12.6884 10.055H13.5284L14.5634 12.91H14.2184L15.2684 10.055H16.0984L14.7234 13.585H14.0484ZM17.8775 13.64C17.5875 13.64 17.3375 13.5933 17.1275 13.5C16.9209 13.4033 16.7309 13.2583 16.5575 13.065L17.0675 12.56C17.1809 12.69 17.3059 12.7916 17.4425 12.865C17.5825 12.935 17.7442 12.97 17.9275 12.97C18.0942 12.97 18.2225 12.94 18.3125 12.88C18.4059 12.82 18.4525 12.7366 18.4525 12.63C18.4525 12.5333 18.4225 12.455 18.3625 12.395C18.3025 12.335 18.2225 12.2833 18.1225 12.24C18.0259 12.1966 17.9175 12.155 17.7975 12.115C17.6809 12.075 17.5642 12.03 17.4475 11.98C17.3309 11.9266 17.2225 11.8616 17.1225 11.785C17.0259 11.705 16.9475 11.6066 16.8875 11.49C16.8275 11.37 16.7975 11.22 16.7975 11.04C16.7975 10.8233 16.8492 10.6366 16.9525 10.48C17.0592 10.3233 17.2059 10.205 17.3925 10.125C17.5792 10.0416 17.7942 9.99996 18.0375 9.99996C18.2842 9.99996 18.5092 10.0433 18.7125 10.13C18.9192 10.2166 19.0892 10.335 19.2225 10.485L18.7125 10.99C18.6059 10.88 18.4975 10.7983 18.3875 10.745C18.2809 10.6916 18.1592 10.665 18.0225 10.665C17.8859 10.665 17.7775 10.6916 17.6975 10.745C17.6175 10.795 17.5775 10.8683 17.5775 10.965C17.5775 11.055 17.6075 11.1283 17.6675 11.185C17.7275 11.2383 17.8059 11.285 17.9025 11.325C18.0025 11.365 18.1109 11.405 18.2275 11.445C18.3475 11.485 18.4659 11.5316 18.5825 11.585C18.6992 11.6383 18.8059 11.7066 18.9025 11.79C19.0025 11.87 19.0825 11.9733 19.1425 12.1C19.2025 12.2233 19.2325 12.3766 19.2325 12.56C19.2325 12.8966 19.1125 13.1616 18.8725 13.355C18.6325 13.545 18.3009 13.64 17.8775 13.64Z" fill="white"/>
  </svg>
);

const AdminIcon = (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 9h6v6H9z"/></svg>
);

const FixturesIcon = (
  <svg width="24" height="21" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="3" width="20" height="16" rx="2" stroke="white" strokeWidth="2" fill="none"/>
    <line x1="16" y1="1" x2="16" y2="5" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    <line x1="8" y1="1" x2="8" y2="5" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    <line x1="2" y1="9" x2="22" y2="9" stroke="white" strokeWidth="2"/>
    <text x="12" y="15" textAnchor="middle" fill="white" fontSize="8">VS</text>
  </svg>
);

const ScoutIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="11" cy="11" r="8" stroke="white" strokeWidth="2"/>
    <path d="M21 21l-4.35-4.35" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15 11a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" stroke="white" strokeWidth="2"/>
  </svg>
);

const TrophyRoomIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 9C6 10.45 6.39 11.8 7.07 12.93L5.07 19.44C5.02 19.62 5.05 19.81 5.16 19.96C5.27 20.11 5.44 20.19 5.62 20.19H18.38C18.56 20.19 18.73 20.11 18.84 19.96C18.95 19.81 18.98 19.62 18.93 19.44L16.93 12.93C17.61 11.8 18 10.45 18 9V6H6V9Z" stroke="white" strokeWidth="2" fill="none"/>
    <path d="M10 2H14" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 6V9" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="12" cy="8" r="1" fill="white"/>
  </svg>
);

const ProfileIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="8" r="4" stroke="white" strokeWidth="2"/>
    <path d="M6 21C6 17.134 8.686 14 12 14C15.314 14 18 17.134 18 21" stroke="white" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const SupportIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="2"/>
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="12" cy="17" r="0.5" fill="white" stroke="white" strokeWidth="1"/>
  </svg>
);

const LegalIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <polyline points="14 2 14 8 20 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="16" y1="13" x2="8" y2="13" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="16" y1="17" x2="8" y2="17" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <polyline points="10 9 9 9 8 9" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const SquadIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="9" cy="7" r="4" stroke="white" strokeWidth="2"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const PricingIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

function getNavItems(userRole, unreadCount = 0, squadNotificationCount = 0) {
  const items = [
    { label: "Dashboard", to: "/dashboard", icon: DashboardIcon },
    { label: "My Competitions", to: "/my-competitions", icon: CompetitionsIcon },
    { label: "Competitions", to: "/competitions", icon: CompetitionsIcon },
    { label: "Fixtures", to: "/fixtures", icon: FixturesIcon },
    { label: "Squad", to: "/squad", icon: SquadIcon, badge: squadNotificationCount > 0 ? squadNotificationCount : undefined },
    { label: "Trophy Room", to: "/trophy-room", icon: TrophyRoomIcon },
    { label: "Profile", to: "/profile", icon: ProfileIcon },
    { label: "Support", to: "/my-tickets", icon: SupportIcon, badge: unreadCount > 0 ? unreadCount : undefined }
  ];

  // Add admin panel only for admin users
  if (userRole === 'admin') {
    items.push({ label: "Admin Panel", to: "/admin/fixtures", icon: AdminIcon });
  }

  return items;
}

export default function SidebarNavbar({ handleLogout, userRole }) {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [legalExpanded, setLegalExpanded] = useState(false);
  const [userId, setUserId] = useState(null);
  
  // Get current user ID for unread tickets and squad notifications
  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUserId(session?.user?.id || null);
    });
  }, []);
  
  const { unreadCount } = useUnreadTickets(userId);
  const { notificationCount: squadNotificationCount } = useSquadNotifications(userId);
  const navItems = getNavItems(userRole, unreadCount, squadNotificationCount);
  return (
    <nav aria-label="Main navigation" data-collapsed={collapsed} className={`hidden md:flex flex-col ${collapsed ? "w-20" : "w-64"} h-screen bg-ui-green py-8 px-2 md:px-6 fixed left-0 top-0 z-40 transition-all duration-200 fc-sidebar`}>
      <div className="flex items-center justify-between mb-10 flex-shrink-0">
        <Link to="/dashboard" aria-label="Footy Coach dashboard" className="text-white text-2xl font-bold hover:underline whitespace-nowrap">{!collapsed && 'Footy Coach'}</Link>
        <FcButton variant="tertiary" type="submit" aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          onClick={() => setCollapsed((c) => !c)}
          className="ml-2"
          title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {/* Simple collapse/expand icon */}
          <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
            {collapsed ? (
              <polyline points="9 18 15 12 9 6" />
            ) : (
              <polyline points="15 18 9 12 15 6" />
            )}
          </svg>
        </FcButton>
      </div>
      
      {/* Scrollable nav items container */}
      <div className="flex-1 overflow-y-auto overflow-x-hidden pr-2 scrollbar-thin scrollbar-thumb-[#BA6830] scrollbar-track-[#1f342e]">
        <ul className="flex flex-col gap-3">
          {navItems.map((item) => (
            <li key={item.label}>
              <FcNavigationLink
                to={item.to}
                className="flex items-center gap-3 text-lg font-semibold px-3 py-3 rounded-lg transition-all duration-200 text-white hover:text-white hover:bg-action-primary"
                title={item.label}
              >
                <span className="relative">
                  {item.icon}
                  {item.badge && item.badge > 0 && <NotificationBadge count={item.badge} />}
                </span>
                {!collapsed && <span>{item.label}</span>}
              </FcNavigationLink>
            </li>
          ))}
        </ul>
      </div>
      
      {/* Legal Section */}
      <div className="mt-4 flex-shrink-0">
        <FcButton variant="tertiary" type="submit" aria-label="Legal"
          onClick={() => setLegalExpanded(!legalExpanded)}
          className="flex items-center justify-between w-full gap-3"
          title="Legal"
        >
          <div className="flex items-center gap-3">
            {LegalIcon}
            {!collapsed && <span>Legal</span>}
          </div>
          {!collapsed && (
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" className={`transition-transform duration-200 ${legalExpanded ? 'rotate-180' : ''}`}>
              <polyline points="6 9 12 15 18 9" />
            </svg>
          )}
        </FcButton>
        
        {legalExpanded && !collapsed && (
          <div className="mt-1 space-y-1">
            <FcNavigationLink
              to="/terms"
              className={`flex items-center gap-3 text-sm px-3 py-2 pl-12 rounded-lg transition-all duration-200 ${location.pathname === '/terms' ? "text-white bg-action-primary" : "text-white hover:bg-action-primary"}`}
            >
              Terms of Service
            </FcNavigationLink>
            <FcNavigationLink
              to="/privacy"
              className={`flex items-center gap-3 text-sm px-3 py-2 pl-12 rounded-lg transition-all duration-200 ${location.pathname === '/privacy' ? "text-white bg-action-primary" : "text-white hover:bg-action-primary"}`}
            >
              Privacy Policy
            </FcNavigationLink>
          </div>
        )}
      </div>
      
      <FcButton variant="tertiary" type="submit" aria-label="Logout"
        onClick={handleLogout}
        className="mt-4 w-full flex-shrink-0"
        title="Logout"
      >
        {!collapsed && 'Logout'}
        {collapsed && (
          <svg width="24" height="24" fill="none" stroke="#284239" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
        )}
      </FcButton>
    </nav>
  );
}
